import { TOGGLE_PARKING_RESEARCH_FROM_INTRO } from "./displayParkingResearchFromIntroReducer"

export const toggleParkingResearchFromIntro= (value) => ({
    type: TOGGLE_PARKING_RESEARCH_FROM_INTRO,
    payload: value
})

